import { Box, Grid, CircularProgress, Typography } from '@material-ui/core'

const CircularPercentage = ({
   value,
   color = 'inherit',
   size = 68,
   backColor = '#fff1',
   thickness = 4,
   ...otherProps
}) => {
   return (
      <Box
         sx={{
            position: 'relative',
            padding: 0,
            marginRight: 10
         }}
      >
         <Grid
            container
            justifyContent="center"
            alignContent="center"
            style={{
               position: 'absolute',
               border: `${thickness + 1}px solid ${backColor}`,
               height: `${size}px`,
               background: '#0001',
               borderRadius: '50%'
            }}
         >
            <Typography variant="body1">{`${Math.floor(value)}%`}</Typography>
         </Grid>
         <CircularProgress
            variant="determinate"
            color={color}
            size={size}
            value={value || 0}
            thickness={thickness}
            {...otherProps}
         />
      </Box>
   )
}

export default CircularPercentage
